/**
 * True when running inside a Tauri WebView (Android, desktop, etc.).
 *
 * Tauri v2 wires IPC through `window.__TAURI_INTERNALS__` and sets `window.isTauri` (see `@tauri-apps/api/core` `isTauri()`).
 * `window.__TAURI__` exists only when `app.withGlobalTauri` is true in `tauri.conf.json`; production builds often omit it,
 * so checking only `__TAURI__` falsely treats the app as non-Tauri.
 *
 * Kept in a tiny module (no `constants` / `__APP_VERSION__`) so Jest can import distribution helpers safely.
 */
export function isTauriRuntime(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  const w = window as Window & {
    isTauri?: boolean
    __TAURI_INTERNALS__?: unknown
    __TAURI__?: unknown
  }
  return Boolean(w.isTauri || w.__TAURI_INTERNALS__ != null || w.__TAURI__ != null)
}
